import React from "react";

const Controls = () => {
  return (
    <div class="flex w-full flex-col gap-8">
      <div class="flex justify-between items-center">
        <div class="w-1/6"></div>
        <div class="w-[18.75%]">
          <div class="bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information]">
            Toggle
          </div>
        </div>
        <div class="w-[18.75%]">
          <div class="bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information]">
            Checkbox
          </div>
        </div>
        <div class="w-[18.75%]">
          <div class="bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information]">
            Check-Round
          </div>
        </div>
        <div class="w-[18.75%]">
          <div class="bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information]">
            Radio
          </div>
        </div>
      </div>
      <div class="flex justify-between items-center">
        <div class="w-1/6">
          <div class="">Active</div>
        </div>
        <div class="w-[18.75%]">
          <label for="switch-1">Switch</label>
          <input type="checkbox" id="switch-1" name="switch-1" role="switch" />
        </div>
        <div class="w-[18.75%]">
          <label for="checkbox-1">Checkbox</label>
          <input type="checkbox" id="checkbox-1" name="checkbox-1" />
        </div>
        <div class="w-[18.75%]">
          <label for="round-1">Check Round</label>
          <input
            type="radio"
            id="round-1"
            name="radio"
            value="radio-1"
            role="check-round"
          />
        </div>
        <div class="w-[18.75%]">
          <label for="radio-1">Radio button</label>
          <input type="radio" id="radio-1" name="radio" value="radio-1" />
        </div>
      </div>
      <div class="flex justify-between items-center">
        <div class="w-1/6">
          <div class="">Disabled</div>
        </div>
        <div class="w-[18.75%]">
          <label for="switch-1">Switch</label>
          <input
            type="checkbox"
            id="switch-1"
            name="switch-1"
            role="switch"
            disabled
          />
        </div>
        <div class="w-[18.75%]">
          <label for="checkbox-1">Checkbox</label>
          <input type="checkbox" id="checkbox-1" name="checkbox-1" disabled />
        </div>
        <div class="w-[18.75%]">
          <label for="round-1">Check Round</label>
          <input
            type="radio"
            id="round-1"
            name="radio"
            value="radio-1"
            role="check-round"
            disabled
          />
        </div>
        <div class="w-[18.75%]">
          <label for="radio-1">Radio button</label>
          <input
            type="radio"
            id="radio-1"
            name="radio"
            value="radio-1"
            disabled
          />
        </div>
      </div>
    </div>
  );
};

export default Controls;
